import React from 'react'
import {colors} from '../../../../colors'
import {SharedIconProps} from '../Icon'

export const IconArrowheadUpSmall = (props: SharedIconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
      <path d="M2 17L12 7L22 17" stroke={props.fill || colors.brand.cobalt} />
    </svg>
  )
}
